<template>
  <div class="image"
    @contextmenu.prevent="preventRightClick"
    ref="imageEl"
    >

    <ImagePlaceholder
      v-if="!disablePlaceholder"
      :imageData="imageData"
      :url="placeholderUrl"
      :isLoaded="isLoaded"
      :displayType="displayType"
      :fixed="fixed"
      @imageLoaded="setPlaceholderLoaded"
    />

    <div
      class="image-render"
      :class="[imageDisplayClass,
      {'image-render--mod-fixed': fixed}]"
      v-bind:style="imageDisplayStyle"
    />

    <ImageElement
      :imageSrc="imageSrc"
      :isIntersected="isIntersected"
      :displayType="displayType"
      :altText="altText"
    />
  </div>
</template>
<script>
import imagesLoaded from 'imagesloaded'
import ImagePlaceholder from './components/ImagePlaceholder/ImagePlaceholder'
import ImageElement from './components/ImageElement/ImageElement'
import CreateImageSrc from './utils/CreateImageSrc'
import getTypeClass from './utils/getTypeClass'
import {defaultImageUrl} from './utils/defaultImages'
import isIE from '@/utils/isIE'
export default {
  name: 'ModuleImage',
  components: {
    ImagePlaceholder,
    ImageElement
  },
  data () {
    return {
      isIntersected: false,
      isLoaded: false,
      observer: null
    }
  },
  props: {
    imageData: Object,
    altText: {
      type: String,
      default: 'An image'
    },
    displayType: {
      type: String,
      default: 'cover'
    },
    imageUrl: {
      type: String,
      default: defaultImageUrl
    },
    placeholderUrl: {
      type: String,
      default: null
    },
    disablePlaceholder: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    lazyLoad: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkImageLoad () {
      const imgLoad = imagesLoaded(this.$refs.imageEl)
      const onDone = (instance) => {
        this.setIsLoaded()
        imgLoad.off('done', onDone)
      }
      imgLoad.on('done', onDone)
    },
    setIsLoaded () {
      this.isLoaded = true
      this.$nextTick(_ => {
        this.$emit('imageLoaded', true)
      })
    },
    setPlaceholderLoaded () {
      this.$emit('placeholderLoaded', true)
    },
    preventRightClick () {
      return false
    },
    intersected (entries, observer) {
      const el = entries[0]
      if (el.isIntersecting) {
        this.isIntersected = true
        this.checkImageLoad()
        this.stopObserve()
      }
    },
    stopObserve () {
      if (this.observer) this.observer.disconnect()
    },
    observeIntersection () {
      const options = {
        root: null,
        rootMargin: `${this.viewport.height * 2}px`,
        threshold: 0
      }
      this.observer = new IntersectionObserver(this.intersected, options)
      this.observer.observe(this.$refs.imageEl)
    }
  },
  computed: {
    imageSrc: function () {
      let src = null
      if (this.isIntersected && this.imageData) {
        const imageSrc = new CreateImageSrc({imageData: this.imageData, containerEl: this.$refs.imageEl})
        src = imageSrc.src || this.imageUrl
      } else if (this.imageUrl) {
        src = this.imageUrl
      }
      return src
    },
    imageDisplayStyle: function () {
      return this.isLoaded ? { backgroundImage: `url(${this.imageSrc})` } : null
    },
    imageDisplayClass () {
      return `image-render${getTypeClass(this.displayType)}`
    }
  },
  mounted () {
    if (this.lazyLoad && !isIE()) {
      this.observeIntersection()
    } else {
      this.isIntersected = true
      this.checkImageLoad()
    }
  },
  destroyed () {
    this.stopObserve()
  }
}
</script>
<style lang="scss" scoped>
  @import './module-image'
</style>



// WEBPACK FOOTER //
// src/modules/ModuleImage/ModuleImage.vue